import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const MOTIVOS = ["No quieren seguir", "Lo piensan", "Por precio", "Por horario", "Van a otro centro"];

export const NoSigueDialog = ({ p, onClose, onPick }) => {
  const [otro, setOtro] = useState("");
  return (
    <Dialog open={!!p} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="no-sigue-dialog">
        <DialogHeader><DialogTitle className="font-[Outfit]">¿Por qué no sigue {p?.nombre}?</DialogTitle></DialogHeader>
        <div className="grid gap-2">
          {MOTIVOS.map((m) => (
            <Button key={m} variant="outline" className="justify-start" data-testid={`no-sigue-${m.toLowerCase().replace(/ /g, "-")}`} onClick={() => onPick(m)}>{m}</Button>
          ))}
          <div className="flex gap-2">
            <Input value={otro} onChange={(e) => setOtro(e.target.value)} placeholder="Otro motivo…" data-testid="no-sigue-otro" />
            <Button disabled={!otro.trim()} onClick={() => onPick(otro.trim())} data-testid="no-sigue-otro-ok" className="bg-[#1E3A8A] hover:bg-[#1E40AF]">Guardar</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
